import { render, staticRenderFns } from "./FitnessAssessmentsEditDialog.vue?vue&type=template&id=53ef5a98&"
import script from "./FitnessAssessmentsEditDialog.vue?vue&type=script&lang=js&"
export * from "./FitnessAssessmentsEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports